var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"takt-journal-day-overview-content"},[_c('div',{staticClass:"takt-journal-day-overview-content-header"},[_vm._t("header")],2),_c('div',{staticClass:"takt-journal-day-overview-content-body",style:(_vm.justify_body?`align-items: ${_vm.justify_body}`:'')},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }